var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.69434 3.97559L20.1133 10.1562C20.8556 10.4771 20.8555 11.5218 20.1133 11.8428L15.5264 13.8076L20 18.2822L18.6152 19.666L2 3.05078L3.38477 1.66602L5.69434 3.97559ZM13.1719 11.4531L16.584 11L12.1201 10.4023L13.1719 11.4531Z",
    fill: "#04B7EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1885 15.2393L4.11719 18.7002C3.51226 18.9658 2.84277 18.516 2.84277 17.8652L2.83398 13.6396C2.83414 13.1814 3.17361 12.7868 3.63184 12.7227L8.96191 12.0127L12.1885 15.2393Z",
    fill: "#04B7EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61523 9.66602L3.63184 9.26758C3.17351 9.21257 2.83398 8.8177 2.83398 8.35938L2.83887 5.88965L6.61523 9.66602Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotSend);
export default __webpack_public_path__ + "static/media/NotSend.f6b51e0333faa21158050b9d784088b4.svg";
export { ForwardRef as ReactComponent };